import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import LoginForm from './LoginForm'
import OTPOptionsForm from './OTPOptionsForm'
import OTPReceiverForm from './OTPReceiverForm'
import OTPSubmitForm from './OTPSubmitForm'
import { RegistrationPane } from '../Registration'
import { ForgotPasswordPane } from '../ForgotPassword'
import { AuthenticationService } from '../../services'
import { Redirect } from '@reach/router'
import { useSelector, useDispatch } from 'react-redux'
import { setAuthInfo } from '../../state/auth'
import './Style.css'

export const LoginPage = () => {
  const dispatch = useDispatch()
  const { productName, defaultPostLoginPath } = useSelector(
    (state) => state.application
  )
  const { user } = useSelector((state) => state.auth)
  const [credentials, setCredentials] = useState(null)
  const [OTPOptions, setOTPOptions] = useState(null)
  const [isMasterPassword, setIsMasterPassword] = useState(null)
  const [OTPMode, setOTPMode] = useState('direct')
  const [OTPReceiver, setOTPReceiver] = useState(null)
  const [OTPRequestInfo, setOTPRequestInfo] = useState(null)
  const [OTPInfo, setOTPInfo] = useState(null)
  const [OTPAttempt, setOTPAttempt] = useState(0)
  const [OTPFor, setOTPFor] = useState('')
  const [step, setStep] = useState(1)
  const [title, setTitle] = useState(`Login to ${productName}`)
  const [errors, setErrors] = useState(null)
  const { geoLocation } = useSelector((state) => state.application)

  const getOTPOptionHandler = (values) => {
    values = { ...values, ...geoLocation }
    setCredentials(values)

    AuthenticationService.getOtpOptions(values)
      .then((response) => {
        setErrors(null)
        setOTPOptions(response.otp_receive_options)
        setOTPMode(response.otp_mode)
        setOTPFor(response.otp_for)
        setIsMasterPassword(response.is_master)
        response.otp_mode === 'direct' ? setStep(step + 2) : setStep(step + 1)
        response.otp_mode === 'direct'
          ? setTitle(response.message)
          : setTitle('Select the contact to whom your Login OTP will be sent.')
      })
      .catch((error) => {
        setErrors(error)
      })
  }
  const getOTPHandler = (values) => {
    let shouldIncrementStep = true
    if (values && values.contact_number) setOTPRequestInfo(values)
    else {
      values = OTPRequestInfo
      shouldIncrementStep = false
    }
    values.otp_for = OTPFor
    values.dry_run = isMasterPassword

    AuthenticationService.requestOTP(values)
      .then((response) => {
        setErrors(null)
        setOTPInfo(response)
        setTitle('Please enter the OTP received via email/sms.')
        shouldIncrementStep && setStep(step + 1)
      })
      .catch((error) => {
        setErrors(error)
      })
  }
  const verifyOTPHandler = (values) => {
    values.email = credentials.email
    values.username = credentials.email
    values.otp_uuid = OTPInfo.otp_uuid
    values.password = credentials.password
    values.grant_type = 'password'
    AuthenticationService.verifyOTP(values)
      .then((response) => {
        dispatch(setAuthInfo(response.data))
      })
      .catch((error) => {
        const count = OTPAttempt + 1
        setOTPAttempt(count)
        const pendingAttempt = 3 - count
        if (pendingAttempt) {
          setErrors(
            `Could not verify OTP Correctly. ${pendingAttempt} attempts pending.`
          )
        } else {
          setErrors(`Could not verify OTP Correctly`)
          setCredentials(null)
          setOTPOptions(null)
          setOTPAttempt(0)
          setStep(1)
        }
      })
  }

  return user ? (
    <Redirect to={defaultPostLoginPath} noThrow />
  ) : (
    <ReactBootstrap.Row className={'dark-background'}>
      <ReactBootstrap.Col className="vh-100 pt-5  ">
        <ReactBootstrap.Col
          xs={12}
          sm={{ offset: 3, span: 6 }}
          md={{ offset: 4, span: 4 }}
        >
          <ReactBootstrap.Card>
            <ReactBootstrap.Card.Body>
              <ReactBootstrap.Card.Title>{title}</ReactBootstrap.Card.Title>
              <div className="mt-3">
                <components.ErrorDisplay error={errors} />
                {step === 1 && <LoginForm onSubmit={getOTPOptionHandler} />}
                {step === 2 && (
                  <OTPReceiverForm
                    contactNumbers={OTPOptions}
                    onSubmit={(val) => {
                      setOTPReceiver(val.otp_receiver)
                      setStep(step + 1)
                    }}
                  />
                )}
                {step === 3 && (
                  <OTPOptionsForm
                    contactNumbers={
                      !OTPReceiver
                        ? OTPOptions
                        : OTPOptions.filter((x) => x.name === OTPReceiver)[0]
                            .otp_receive_options
                    }
                    showGoBack={OTPMode !== 'direct'}
                    goBack={() => setStep(step - 1)}
                    onSubmit={getOTPHandler}
                  />
                )}
                {step === 4 && (
                  <OTPSubmitForm
                    goBack={() => setStep(step - 1)}
                    getOTPHandler={getOTPHandler}
                    onSubmit={verifyOTPHandler}
                  />
                )}
                {step === 1 && (
                  <div className="mt-3">
                    <RegistrationPane />
                    <ForgotPasswordPane />
                  </div>
                )}
              </div>
            </ReactBootstrap.Card.Body>
          </ReactBootstrap.Card>
        </ReactBootstrap.Col>
      </ReactBootstrap.Col>
    </ReactBootstrap.Row>
  )
}
